// src/copy/terms.js

// Keep internal names stable; only map what the UI shows.
// Comments in English as requested.

export const TERMS = {
    // ClientServiceSubscription (instance for a client)
    subscription_singular: "Service",
    subscription_plural: "Services",

    // Service (template/catalog item)
    serviceTemplate_singular: "Service",
    serviceTemplate_plural: "Services",

    // Jobs / pipelines (if you show them)
    pipeline_singular: "Pipeline",
    pipeline_plural: "Pipelines",

    // Tasks / steps
    step_singular: "Step",
    step_plural: "Steps",
};

export function term(key) {
    return TERMS[key] || key;
}
